import { useTranslation } from 'react-i18next'
import React from 'react'

import { useSegmentationForm } from '../_form/SegmentationFormHandler'
import FlexGrid, { FlexCol } from '../../../../components/structure/FlexGrid'
import LabelValue from '../../../../components/presentation/LabelValue'
import formatLocalPersonLabel from '../../_helpers/formatLocalPersonLabel'
import { usePlaceTypes } from '../../../../utils/helpers/placeTypes'

export const useResumeStepDef = () => {
  return {
    title: 'resumeStep.title',
    subtitle: 'resumeStep.subtitle',
    Component: ResumeStep,
    validate: () => [true]
  }
}

const ResumeStep = () => {
  const { t } = useTranslation('editSegmentation')
  const [placeTypes] = usePlaceTypes()
  const segmentation = useSegmentationForm()

  const segmentUserGroup = segmentation?.userGroups?.map(item => item.name)?.join(', ') || ''
  const segmentChecklistType = segmentation?.checklistTypes?.map(item => item.name)?.join(', ') || ''
  const segmentAssets = segmentation?.assets?.map(item => item?.name)?.join(', ') || ''

  const placeLevelsByPlaceType = placeTypes.map(type => {
    return {
      type,
      placeLevels: (segmentation?.placeLevels || [])
        .filter(item => item.type === type.key)
        .map(item => formatLocalPersonLabel(item))
        .join(', ')
    }
  })

  const hasAllPlacesSelected = segmentation?.placeLevels?.includes('all')

  return (
    <FlexGrid justify="flex-start" align="flex-start" paddingGutter={0.5} wrap>
      <FlexCol width="50%">
        <LabelValue
          label={t('checklistTypes.title')}
          children={segmentChecklistType.length ? segmentChecklistType : t('all')}
        />
      </FlexCol>

      <FlexCol width="50%">
        <LabelValue label={t('groupStep.title')} children={segmentUserGroup.length ? segmentUserGroup : t('all')} />
      </FlexCol>

      <FlexCol width="50%">
        <LabelValue label={t('assetStep.title')} children={segmentAssets.length ? segmentAssets : t('all')} />
      </FlexCol>

      {placeLevelsByPlaceType.map(item => {
        if (hasAllPlacesSelected || item.placeLevels) {
          return (
            <FlexCol key={item.type.key} width="50%">
              <LabelValue
                label={item.type.namePlural}
                value={!hasAllPlacesSelected ? item.placeLevels : t('ignoring')}
              />
            </FlexCol>
          )
        }
        return undefined
      })}
    </FlexGrid>
  )
}

export default ResumeStep
